import React from 'react'
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler
);

export const options = {
  responsive: true,
  aspectRatio: 4,
  plugins: {
    title: {
      display: false,
      text: "Nombre de plateaux scannés par mois en mode IA et en mode semi-manuel"
    },
    legend: {
      display: true
    }
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: true
      },
    },
    y: {
      stacked: true,
      grid: {
        display: true
      },
      ticks: {
        min: 50,
        // suggestedMin: 50,
        stepSize: 10,
      }
    }
  }
};

const getDataset = (data: any) => {
  if (data === 'ERR_NETWORK') return []
  let list: { label: string, data: number[], backgroundColor: string, grouped: boolean }[] =
    [{
      label: "Nombre de plateaux en mode manuel",
      data: [],
      backgroundColor: '#f96384',
      grouped: true
    },
    {
      label: 'Nombre de plateaux en mode IA',
      backgroundColor: '#36a2eb',
      data: [],
      grouped: true
    },
    {
      label: 'Nombre de plateaux en mode IA Forcé',
      data: [],
      backgroundColor: '#FFA500',
      grouped: true
    }
    ]

  data.forEach((elem: { ia: number, photo: number, forced: number }) => {
    list[0].data.push(elem.photo)
    list[1].data.push(elem.ia)
    list[2].data.push(elem.forced)
  })
  return list
}

const formatData = (data: any) => {
  const labels = data.map((elem: { _id: string }) => elem._id)
  const dataset = getDataset(data)

  return {
    labels,
    datasets: dataset
  }
}

const ControledTrayChart = (props: { data: any }) => {
  const { data } = props

  return (
    <Bar options={options} data={formatData(data)} />
  )
}

export default ControledTrayChart